define([
    "./emailModule",
    "./emailService",
    "./template/emailTemplateController",
    "./template/legendsEmailModal",
    "./emailRouter"
], function () {
});